"use strict";

import "../scss/main.scss";

// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

import "./components/navigation.js";

import "./components/cookie-bar.js";

if (document.querySelector('.swiper-gallery')) {
  const swiper = new Swiper('.swiper-gallery', {
    modules: [Navigation, Pagination, Autoplay],
    loop: false,
    effect: 'slide',
    speed: 300,
    slidesPerView: 1,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 5000,
    // },
    navigation: {
      nextEl: '.swiper-gallery-button-next',
      prevEl: '.swiper-gallery-button-prev',
    },
    pagination: {
      el: ".swiper-gallery-pagination",
      clickable: true,
    }
  });
}

